module.exports = __webpack_public_path__ + "img/scene5-18.83af54ab.png";